import React from 'react'

export interface HealthBarProps {
  /** Progress value from 0 to 100 */
  progress: number;
  /** Text to display on the bar */
  text?: string;
  /** Width of the bar in pixels */
  width?: number;
  /** Height of the bar in pixels */
  height?: number;
  /** Whether to show the cursor indicator */
  showCursor?: boolean;
  /** Cursor position from 0 to 100 */
  cursorPosition?: number;
  /** Whether the bar is selected/active */
  selected?: boolean;
  /** Custom CSS class */
  className?: string;
  /** Custom styles */
  style?: React.CSSProperties;
}

export const HealthBar: React.FC<HealthBarProps> = ({
  progress,
  text = '',
  width = 200,
  height = 20,
  showCursor = false,
  cursorPosition = 0,
  selected = true,
  className = '',
  style = {},
}) => {
  const containerStyle: React.CSSProperties = {
    position: 'relative',
    width: `${width}px`,
    height: `${height}px`,
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    border: '1px solid rgba(255, 255, 255, 0.7)',
    // borderRadius: '2px',
    overflow: 'hidden',
    filter: selected ? 'none' : 'grayscale(1)',
    opacity: selected ? 1 : 0.5,
    ...style,
  }

  const progressStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: `${Math.max(0, Math.min(100, progress))}%`,
    background: `linear-gradient(to right, #ff0000 0px, #ffff00 ${width / 2}px, #00ff00 ${width}px)`,
    // background: `linear-gradient(90deg, #ff4000 0px, #80ff00 ${width}px)`,
  }

  const cursorStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: `${Math.max(0, Math.min(100, cursorPosition))}%`,
    width: '2px',
    height: '100%',
    backgroundColor: '#ffffff',
    pointerEvents: 'none',
    transform: 'translateX(-50%)',
  }

  const textStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#000000',
    padding: '2px',
    fontSize: `${Math.max(10, height * 0.6)}px`,
    fontFamily: 'monospace',
    // textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8)',
    pointerEvents: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: `${width}px`,
  }

  return (
    <div className={className} style={containerStyle}>
      {/* Progress bar */}
      <div style={progressStyle} />

      {/* Cursor indicator */}
      {showCursor && (
        <div style={cursorStyle} />
      )}

      {/* Text overlay */}
      {text && (
        <div style={textStyle}>
          {text}
        </div>
      )}
    </div>
  )
}

export default HealthBar
